import React from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import SubsidiariesSection from '../components/SubsidiariesSection';
import Contact from '../components/Contact';

const Home: React.FC = () => {
  return (
    <main>
      <Hero />
      <AboutSection />
      <SubsidiariesSection />
      <Contact />
    </main>
  );
};

export default Home;
